document.documentElement.classList.remove('no-js');

class ZealMenu extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-menu-toggle]');
    this.panel = this.querySelector('[data-menu-panel]');
    if (!this.button || !this.panel) return;
    this.button.addEventListener('click', () => this.toggle());
    this.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => this.close()));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') this.close(); });
  }
  toggle() {
    const open = this.button.getAttribute('aria-expanded') === 'true';
    this.button.setAttribute('aria-expanded', String(!open));
    this.panel.hidden = open;
    document.body.classList.toggle('menu-open', !open);
  }
  close() {
    this.button.setAttribute('aria-expanded', 'false');
    this.panel.hidden = true;
    document.body.classList.remove('menu-open');
  }
}
customElements.define('zeal-menu', ZealMenu);

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-quantity]');
  if (!trigger) return;
  const input = trigger.parentElement.querySelector('input');
  const delta = trigger.dataset.quantity === 'plus' ? 1 : -1;
  input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + delta);
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

